import React from "react";
import {
  EmptyStar,
  FilledStar,
  HalfFilledStar,
} from "../../../images/svgIcons/svg";

interface LocationReviewsProps {
  googleRating: number;
  googleReviews: number;
}
const LocationReviews: React.FC<LocationReviewsProps> = ({
  googleRating,
  googleReviews,
}) => {
  const totalStars = 5;
  const filledStars = Math.floor(googleRating);
  const halfStars = googleRating - filledStars >= 0.3;
  const emptyStars = totalStars - filledStars - (halfStars ? 1 : 0);

  return (
    <div className="d-flex align-items-center justify-content-center cz-mt-30">
      <p className="font-Trade-regular f-s18 pe-2 d-flex align-items-center gap-2">
        <div className="d-flex align-items-center gap-1">
          {typeof googleRating === "string" &&
            parseFloat(googleRating).toFixed(1)}

          {[...Array(filledStars)].map(() => {
            return <FilledStar />;
          })}
          {halfStars && <HalfFilledStar />}
          {[...Array(emptyStars)].map(() => {
            return <EmptyStar />;
          })}
        </div>
      </p>

      <p className="text-decoration-underline font-Trade-regular f-s18 border-start ps-2">
        {" "}
        {googleReviews} Reviews
      </p>
    </div>
  );
};

export default LocationReviews;
